import { Component, Prop, Ref, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { formatMoney } from '@/utils/formatting';

interface PricingData {
    name: string;
    handle: string;
    cost: number;
    total: number|null;
}

@Component
export class PricingCalculator extends ThemeComponent {
    @Ref() multiplierInput!: HTMLInputElement;
    @Ref() formButton!: HTMLButtonElement;
    @Ref() results!: HTMLDivElement;
    @Prop() pricingData!: PricingData[];

    private recommendedProductHandle!: string|null;

    init() {
        this.$listen(this.formButton, 'click', () => {
            if (!this.multiplierInput.checkValidity() || this.multiplierInput.value == '') {
                // In order to trigger the :invalid state of the input
                // (particularly if it's empty) we can add the required attribute
                this.multiplierInput.required = true;
                this.hideTotals();
                return;
            }
            this.renderTotals();
        });
    }

    renderTotals() {

        this.classList.add('pricing-calculator--active');

        // Add the totals to a new array
        const pricingDataWithTotals = this.pricingData.map((item) => {
            item.total = item.cost * Number(this.multiplierInput.value);
            return item;
        });

        for (const item of pricingDataWithTotals) {
            const totalElement = this.querySelector(`.total__${item.handle}`);
            if (totalElement) {
                totalElement.innerHTML = String(formatMoney(item.total));
            }
        }

        const recommendedItem = pricingDataWithTotals.reduce((result, item) => {
            if (result.total && item.total) {
                return result.total < item.total ? result : item;
            } else {
                return item as PricingData;
            }
        }, {} as PricingData);

        if (recommendedItem) {
            this.recommendedProductHandle = recommendedItem.handle;
        }

        this.results.scrollIntoView();

    }

    hideTotals() {
        this.classList.remove('pricing-calculator--active');
    }

    @Watch('recommendedProductHandle')
    highlightColumn() {
        const cellsToHighlight = this.querySelectorAll(`.cell__${this.recommendedProductHandle}`);
        if (this.recommendedProductHandle && cellsToHighlight) {
            for (const cell of cellsToHighlight) {
                cell.classList.add('cell--highlight');
            }
        }
    }

}
